import { RequestDocumentData } from "../Request/RequestDocumentData";
import OtherParentDataCheckStatusEnum from "./OtherParentDataCheckStatusEnum";
import ParentshipTypeEnum from "./ParentshipTypeEnum";
import Residence from "./Residence";

export default interface OtherParent {
  id: number;
  oib: string;
  firstName: string;
  lastName: string;
  sexId?: number;
  sexName: string;
  dateOfBirth?: Date;
  countryOfBirthId?: number;
  countryOfBirthName: string;
  birthplaceId?: number;
  birthplaceName: string;
  citizenshipId?: number;
  citizenshipName: string;
  nationalMinorityId?: number;
  nationalMinorityName?: string;
  nationalityId?: number;
  nationalityName?: string;
  parentshipTypeId?: ParentshipTypeEnum;
  parentshipTypeName?: string;
  custody?: string;
  professionId?: number;
  professionName?: string;
  professionalQualificationId?: number;
  professionalQualificationName?: string;
  email?: string;
  phoneNumber: string;
  permanentResidence?: Residence;
  temporaryResidence?: Residence;
  integrationResultStatus?: OtherParentDataCheckStatusEnum;
  yearOfBirth?: number;
  documents: RequestDocumentData[];
  isCustodyConfirmed?: boolean | undefined;
  isConfirmedParentChildRelationByDocument: boolean;
  isOibNotExistent: boolean;
  documentNumber?: string;
  documentTypeId?: number;
  documentTypeName?: string;
  reasonNonExistenceOibId?: number;
  reasonNonExistenceOibName?: string;
}

export const CreateUpdateOtherParentInital: OtherParent = {
  id: 0,
  oib: "",
  firstName: "",
  lastName: "",
  sexId: undefined,
  sexName: "",
  dateOfBirth: undefined,
  countryOfBirthId: undefined,
  countryOfBirthName: "",
  birthplaceId: undefined,
  birthplaceName: "",
  citizenshipId: undefined,
  citizenshipName: "",
  nationalMinorityId: undefined,
  nationalMinorityName: "",
  nationalityId: undefined,
  nationalityName: "",
  parentshipTypeId: undefined,
  parentshipTypeName: "",
  custody: "",
  professionId: undefined,
  professionName: undefined,
  professionalQualificationId: undefined,
  professionalQualificationName: undefined,
  email: "",
  phoneNumber: "",
  yearOfBirth: undefined,
  permanentResidence: undefined,
  temporaryResidence: undefined,
  integrationResultStatus: undefined,
  documents: [],
  isCustodyConfirmed: undefined,
  isConfirmedParentChildRelationByDocument: false,
  isOibNotExistent: false,
  documentNumber: undefined,
  documentTypeId: undefined,
  documentTypeName: undefined,
  reasonNonExistenceOibId: undefined,
  reasonNonExistenceOibName: undefined,
};
